import { Requester } from './Requester';
import { IOrganization, IManifest } from '../types';

export const PatchOrganization = async ({
    orgId,
    organization,
    surveyId
}: {
    orgId: string;
    organization: IManifest;
    surveyId?: string;
}): Promise<IOrganization | null> => {
    try {
        const response = await Requester<IOrganization | null>({
            path: `organizations/${orgId}`,
            method: 'PATCH',
            payload: organization,
            searchParams: surveyId ? `surveyId=${surveyId}` : undefined
        });

        return response && Object.hasOwn(response, '_id') ? (response as IOrganization) : null;
    } catch (e) {
        console.error('Patch organization request failed');
        return Promise.reject(e);
    }
};
